import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { LoaderService } from 'src/app/Services/loader.service';
import { ActivatedRoute } from '@angular/router';
import { WebsiteService } from 'src/app/Services/website.service';
import html2canvas from 'html2canvas';
import { appConfig } from 'src/app/app.config';
import { AdminService } from 'src/app/Services/admin.service';
// import proxy from 'html2canvas-proxy';
// import express from 'express';

@Component({
  selector: 'app-kpi',
  templateUrl: './kpi.component.html',
  styleUrls: ['./kpi.component.css']
})
export class KpiComponent implements OnInit {

  @ViewChild('mapViewNode', { static: true }) private mapViewEl: ElementRef;

  base_address: string = appConfig.apiUrl + 'admin/';

  quarter:Number = 1;
  year:Number = 2019;
  kpis:any
  filteredKpis:any;
  selectedkpi:any = {};
  kpistatues:any;
  dataready:boolean = false;
  notApplicable = 0;
  searchText = '';
  selectedOutputName = '';

  outputList:any;
  selectedOutput:Number=0;

  mapsData:any;
  mapOne:any;
  mapTwo:any;
  yearsList:any;

  constructor(private route: ActivatedRoute,
    private loader: LoaderService, private adminService: AdminService,
    private websiteser: WebsiteService) { }

  ngOnInit() {

    setTimeout(() => {
      this.loader.hideLoader();
    }, 300);
    this.adminService.LoadYearsList().subscribe((data:any) => {
      console.log(data);
      this.yearsList = data.result;
      this.year = (new Date()).getFullYear();
      this.quarter = Math.floor(((new Date()).getMonth() +1) / 4)+1;
  
      this.kpis = this.route.snapshot.data.data.result;
      this.filteredKpis = this.kpis;
      this.kpistatues = this.route.snapshot.data.status.result;
  
      this.selectedkpi = this.kpis[0];
      this.getMapsData();
    });

    this.adminService.GetActiveGpwOutputs().subscribe((data:any) => {
      console.log(data);
      this.outputList = data.result;
      let selectedOutputRecord = this.outputList.filter((item)=>item.id == this.selectedkpi.groupId)[0];
      this.selectedOutputName = selectedOutputRecord.code +' '+selectedOutputRecord.gpwoutput;  
      this.outputList.forEach(x=>{
        if(x.gpwoutput.length>150)
        x.gpwoutput=x.gpwoutput.substring(0,150)+'...';
        });
    });

  }

  selectKpi(id){
    this.loader.showLoader();
    this.selectedkpi = this.kpis.filter((item) => item.id == id)[0];
    let selectedOutputRecord = this.outputList.filter((item)=>item.id == this.selectedkpi.groupId)[0];
    this.selectedOutputName = selectedOutputRecord.code +' '+selectedOutputRecord.gpwoutput;
    this.getMapsData();
  }

  getMapsData(){
    this.dataready = false;
    this.websiteser.GetKpiBcResults(this.selectedkpi.id, this.year, this.quarter).subscribe((data:any) => {
      this.mapsData = data.result;
      // this.mapsData.thresholdValue = this.mapsData.thresholdValue.replace(new RegExp('\n', 'g'), "<br />");
      this.mapOne = this.mapsData.baseLineResults;
      this.mapTwo = this.mapsData.currentResults;
      this.dataready = true;
      this.notApplicable = this.mapsData.budgetCentersCount;
      for(let i = 0; i < this.mapsData.kpisStatusesValues.length; i++)
      {
        this.notApplicable -= this.mapsData.kpisStatusesValues[i].value;
      }
      this.loader.hideLoader();
    })
  }

  getcolorData(index){
    return this.mapsData.kpisStatusesValues.find(x => x.id == index+1);
  }

  public captureScreen() {

    this.loader.showLoader();

    var data = document.getElementById('main-data-div');
//
     //var proxy = require("./server.js");
    // var express = require('express');

     //var app = express();
    // var port = (process.env.PORT || 3000);

    // app.use("/", proxy());

    // console.log("Server running on port", port);
    // app.listen(port);
    html2canvas(data , { useCORS : true, logging: true, allowTaint: true, proxy:'./server.js'}).then(canvas => {
      const contentDataURL = canvas.toDataURL('image/png')
      this.loader.hideLoader();
      console.log(contentDataURL);
    });
  }

  searchTextchanged()
  {
    console.log(this.searchText);
    if(this.selectedOutput == 0)
    {
      if(this.searchText.length == 0)
      {
        this.filteredKpis = this.kpis;
      }
      else{
        this.filteredKpis = this.kpis.filter(x=>x.value.toLowerCase().indexOf(this.searchText.toLowerCase()) > -1);
      }  
    }
    else{
      if(this.searchText.length == 0)
      {
        this.filteredKpis = this.kpis.filter(x=>x.groupId == this.selectedOutput);
      }
      else{
        this.filteredKpis = this.kpis.filter(x=>(x.groupId == this.selectedOutput)&&(x.value.toLowerCase().indexOf(this.searchText.toLowerCase()) > -1));
      }  
    }
  }

  selectedOutputChanged(){
    if(this.selectedOutput == 0)
    {
      this.filteredKpis = this.kpis;
    }
    else{
      this.filteredKpis = this.kpis.filter(x=>x.groupId == this.selectedOutput);
    }
  }
}
